/* Ordinia — "Avísame cuando vuelva": se muestra solo con la variante agotada y anota cuál es. */
(function () {
  if (window.__ordAvisame) return;
  window.__ordAvisame = true;
  document.addEventListener('variant:update', function (event) {
    var v = event.detail && event.detail.resource;
    if (!v) return;
    document.querySelectorAll('[data-ord-avisame]').forEach(function (box) {
      var pid = event.detail.data && event.detail.data.productId;
      if (pid && String(pid) !== box.getAttribute('data-product-id')) return;
      box.hidden = !!v.available;
      var field = box.querySelector('[data-ord-avisame-variant]');
      if (field) field.value = v.title || v.public_title || '';
    });
  });
})();
